import React from "react";

const PageLoader = ({ text = "" }) => {
  return (
    <div className="page-loader-container">
      <div className="spinner-border my-2" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-dark mt-1">{text}</p>
    </div>
  );
};

export default PageLoader;
